import { z } from "zod";

export const ingredientFormSchema = z.object({
    name: z.string().trim().min(1, "form.required_field"),
    clientId: z.string().optional(),
    ingredientReferenceId: z.number().optional(),
    organic: z.boolean().optional(),
    ownedBy: z.object({
        "@id": z.string(),
        id: z.number(),
        name: z.string(),
    }),
    ingredientLine: z
        .object({
            "@id": z.string(),
            name: z.string(),
        })
        .optional(),
    tags: z.record(z.string(), z.array(z.string())).optional(),
});

export type IngredientFormData = z.infer<typeof ingredientFormSchema>;
